import request from '@/axios/customerComplaint'

// F-05-反馈订单列表
export function getFeedbackOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getFeedbackOrderList',
    method: 'post',
    data
  })
}

// F-06-反馈订单问题列表
export function getComplaintList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintList',
    method: 'post',
    data
  })
}

// F-07-问题处理详情
export function getComplaintInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintInfo',
    method: 'post',
    data
  })
}

// F-08-客诉处理
export function dealComplaint(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/dealComplaint',
    method: 'post',
    data
  })
}

// 问题选项
export function getFields(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/feedback/getFields',
    method: 'post',
    data
  })
}

// F-04-客户问题反馈
export function addComplaint(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/complaint/addComplaint',
    method: 'post',
    data
  })
}

// F-08-问题详情(v2.1)
export function addComplaintDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintDetail',
    method: 'post',
    data
  })
}

// F-09-添加处理过程(v2.1)
export function addLog(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/addLog',
    method: 'post',
    data
  })
}

// 获取服务岗位员工列表(v1.1)
export function getRolesStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getRolesStaffList',
    method: 'post',
    data
  })
}
